import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 토큰 가지고 오기
const getMain = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tomonth: "",
    daycnt: 0,
    playercntmonth: 0,
    playercnttotal: 0,
    playerlist: [],
    ownercntmonth: 0,
    ownercnttotal: 0,
    ownerlist: [],
    gamestopcntmonth: 0,
    gamestopcnttotal: 0,
    gamestoplist: [],
    gameendcntmonth: 0,
    gameendcnttotal: 0,
    gameendlist: [],
    tournamentcntmonth: 0,
    tournamentcnttotal: 0,
    tournamentlist: [],
    eventwinningcntmonth: 0,
    eventwinningcnttotal: 0,
    eventwinninglist: [],
  };
  const options = {
    method: "GET",
    timeout: 50000,
    url: "/main",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: param,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("getToken", err);
    result(false, err);
  }
};

// 파일 업로드 테스트
const saveFileTest = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "http://127.0.0.1/test.php",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);

        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};

export default {
  getMain,
  saveFileTest,
};
